import { OnInit, OnDestroy, ViewChild, ElementRef, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';

declare let dojoApp: any;

@Component({
    selector: 'dojo-my-documents',
    templateUrl: './dojo-mydocuments.component.html'
})
export class DojoMyDocumentsComponent implements OnInit, AfterViewInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    equipt: boolean = false;
    isAdaTheme: boolean = false;
    adaptiveUser: boolean = false;
    title: string;
    ismobile: boolean = false;

    @ViewChild('statementsFilter') gridfilter: ElementRef;
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        private nxiwidgetParamsService: NxiWidgetParamsService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.ismobile = true;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'dojo-my-documents';
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getMyDocumentParams();
        });
    }

    ngAfterViewInit(): void {
        if (this.ismobile) {
            document.getElementById('SharedDocumentsFilterDiv').style.opacity = '0';
            document.getElementById('SharedDocumentsFilterDiv').style.height = '0';
            document.getElementById('filterSection').style.display = 'none';
        }
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyMyDocuments();
        }
    }

    renderDojoWidget(myDocumentParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderMyDocuments(myDocumentParams);
        }
    }

    getMyDocumentParams() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiwidgetParamsService.getWidgetParams(this.acctRef, 'myDocuments').subscribe(
                resp => {
                    console.log('Retrieved common REST My documents widgets param : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        this.equipt = resp.response.equipt;
                        this.adaptiveUser = resp.response.adaptiveUser;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

    handleCheckbox(event: any) {
        if (event.checked) {
            this.gridfilter.nativeElement.domStyle = "{'opacity': '1','height', 'auto'}";
        } else {
            this.gridfilter.nativeElement.domStyle = "{'opacity': '0','height', '0'}";
        }
    }

    handleMyDocFilter(event: any) {
        console.log(event.checked);
        if (event.checked) {
            console.log('inside true');
            document.getElementById('SharedDocumentsFilterDiv').style.opacity = '1';
            document.getElementById('SharedDocumentsFilterDiv').style.height = 'auto';
            document.getElementById('filterSection').style.display = 'block';
        } else {
            document.getElementById('SharedDocumentsFilterDiv').style.opacity = '0';
            document.getElementById('SharedDocumentsFilterDiv').style.height = '0';
            document.getElementById('filterSection').style.display = 'none';
            console.log('inside false');
        }

    }

    gotoRoute(page: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail:
            {
                'gotoPage': page,
                'gotoParams': { 'accountRef': this.acctRef }
            }
        }));
    }

}
